import styled from "styled-components";
import { Link } from "react-router-dom";
import { palette, typography } from "@src/core/styles";

export const ToolsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
`;

export const ToolCard = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid ${palette.colors.outline_variant};
  background-color: ${palette.colors.surface};
  color: ${palette.colors.onsurface};
  text-decoration: none;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${palette.colors.green_base};
    background-color: ${palette.colors.surface_container};
    transform: translateY(-2px);
  }
`;

export const ToolCardTitle = styled.div`
  ${typography.title_medium};
  color: ${palette.colors.onsurface};
`;

export const ToolCardDesc = styled.div`
  ${typography.body_medium_regular};
  color: ${palette.colors.onsurface_variant};
`;

export const CategoryLabel = styled.span`
  ${typography.label_small_medium};
  text-transform: uppercase;
  color: ${palette.colors.green_base};
  letter-spacing: 0.5px;
`;
